import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAppointmentStore from "../store/useAppointmentStore";
import useAuth from "../store/useAuth";

export const QRRedirectHandler = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const setSelectedFacility = useAppointmentStore(
    (state) => state.setSelectedFacility
  );
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      try {
        const decodedFacilityId = Number(atob(decodeURIComponent(token)));
      
        setSelectedFacility(decodedFacilityId);
        localStorage.setItem("selectedFacilityId", decodedFacilityId.toString());
        localStorage.setItem("hospitalSelected", "true");
        
        // Indicate that we're in a QR flow and where to redirect after auth
        localStorage.setItem("fromQR", "true");
        sessionStorage.setItem("qrFacilityId", decodedFacilityId.toString());
        sessionStorage.setItem("qrRedirectTarget", "/qr-doctors");
        
        if (isAuthenticated) {
          navigate("/qr-doctors", { replace: true });
        } else {
          localStorage.setItem("appInitialized", "initializing");
          navigate("/get-user", { 
            state: { 
              fromQR: true,
              facilityId: decodedFacilityId
            },
            replace: true 
          });
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate("/hospitals", { replace: true }); 
      }
    } else {
      // No token provided, redirect to hospitals selection
      navigate("/hospitals", { replace: true });
    }
  }, [searchParams, navigate, setSelectedFacility, isAuthenticated]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="animate-pulse">Redirecting...</div>
    </div>
  );
};